import Vue from 'vue'

const toast = {i, w, s, e}
const loading = {show, hide}

export {
  alert,
  confirm,
  toast,
  loading
}

function alert (...args) {
  let n = args.length - 1
  let onHide = typeof args[n] === 'function' ? args[n--] : null
  let content = args[n--]
  let title = n >= 0 ? args[n] : ''
  Vue.$vux.alert.show({title, content, onHide})
}

function confirm (...args) {
  let n = args.length - 1
  let onConfirm = typeof args[n] === 'function' ? args[n--] : null
  let onHide = null
  if (typeof args[n] === 'function') {
    onHide = onConfirm
    onConfirm = args[n--]
  }
  let content = args[n--]
  let title = n >= 0 ? args[n] : ''
  Vue.$vux.confirm.show({title, content, onConfirm, onHide})
}

function _toast (type, text) {
  Vue.$vux.toast.show({type, text})
}

function i (text) {
  _toast('text', text)
}

function w (text) {
  _toast('warn', text)
}

function s (text) {
  _toast('success', text)
}

function e (text) {
  _toast('cancel', text)
}

function show (text) {
  Vue.$vux.loading.show({text})
}

function hide () {
  Vue.$vux.loading.hide()
}



// WEBPACK FOOTER //
// ./src/utils/dlg.js